<ion-content [scrollY]="false">
  <div class="pictogram-modal">
    <!-- Header -->
    <div class="modal-header">
      <span class="modal-title">{{'Add from Pictogram Library' | translate}}</span>
      <div class="close-icon" tabindex="0" role="button" (keydown.enter)="close()" (keydown.space)="close()" (click)="close()">
        <img tooltip="{{'Close' | translate}}" alt="close" placement="bottom" src="/assets/icon/cancel.svg">
      </div>
    </div>

    <!-- Category Dropdown -->
    <div class="category-section">
      <ion-label class="category-label">{{'Category Name' | translate}}</ion-label>
      <ng-select
        [items]="categories"
        [(ngModel)]="selectedCategory"
        (ngModelChange)="onCategoryChange($event)"
        bindLabel="name"
        [placeholder]="'Select Category' | translate"
        [clearable]="false"
        class="category-dropdown">
      </ng-select>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && displayedImages.length === 0">
      <span>{{'No pictogram images available currently.' | translate}}</span>
    </div>

    <!-- Image Grid -->
    <div class="image-grid" *ngIf="!isLoading && displayedImages.length > 0">
      <div
        class="image-card-wrapper"
        *ngFor="let image of displayedImages"
        (click)="toggleImageSelection(image)"
        [ngClass]="{
          'selected': isSelected(image),
          'already-added': isAlreadyAdded(image)
        }">
        <div class="image-card">
          <img [src]="image.thumbnailUrl || image.url" [alt]="image.fileName" [title]="image.fileName" (error)="handleImageError($event)">
          <div class="checkbox-overlay">
            <ion-checkbox
              [checked]="isSelected(image)"
              [disabled]="isAlreadyAdded(image)"
              mode="md"
              (ionChange)="toggleImageSelection(image)"
              (keydown.space)="onCheckboxKeydown($event)"
              (click)="$event.stopPropagation()">
            </ion-checkbox>
          </div>
        </div>
        <span class="image-name" [title]="image.fileName">{{image.fileName}}</span>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <div class="modal-footer">
    <span class="selection-count">{{selectedImages.size}} {{'selected' | translate}}</span>
    <div class="footer-buttons">
      <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="close()">
        {{'Cancel' | translate}}
      </ion-button>
      <ion-button class="app-btn" shape="round" fill="outline" color="primary"
        [disabled]="selectedImages.size === 0"
        (click)="upload()">
        {{'Add Images' | translate}}
      </ion-button>
    </div>
  </div>
</ion-footer>
